import * as React from 'react';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';

type Props = {
    createdTime: number;
};

export function SavedListCreatedTime(props: Props) {
    return (
        <div className='flex align-center'>
            Created&nbsp;
            <FormattedTimestamp
                format={FormattedTimestamp.formats.longMonthDayWithYear}
                datetime={props.createdTime}
            />
        </div>
    );
}
